import { filter } from "lodash";
import { create } from "zustand";

import { Song } from "../types/song.types";
import { getFormattedSong } from "./general.helper";

interface MusicPlayer {
  isLoading: boolean;
  error: string;
  songs: Song[];
  currentSongIndex: number;
  playList: any;
  isShuffle: boolean;
  isRepeat: boolean;
  searchedSong: Song;
  toggleIsShuffle: (val: boolean) => void;
  toggleIsRepeat: (val: boolean) => void;
  setPlayList: (playList: any) => void;
  setSongs: (songs: Song[], songIndex?: number) => void;
  setCurrentSongIndex: (index: number) => void;
  playSearchSong: (song: Song) => void;
  isPlaying: boolean;
  setIsPlaying: (isPlaying: boolean) => void;
  aoudioRef1: any;
  setAudioRef1: (ref: object) => void;
  audioRef2: any;
  setAudioRef2: (ref: object) => void;
  currentAudioRefIndex: any;
  setCurrentAudioRefIndex: (index: object) => void;
  setPlayListFromScoket: (
    playList: any,
    songs: Song[],
    songIndex: number
  ) => void;
  beforeShuffleSongs: Song[];
  setBeforeShuffleSongs: (songs: Song[]) => void;
}

const getInitialShuffle = (): boolean => {
  try {
    const stored = localStorage.getItem('4play_shuffle');
    if (stored !== null) return stored === 'true';
  } catch (_) {}
  return true;
};

const musicPlayerStore = create<MusicPlayer>((set) => ({
  isLoading: false,
  error: "",
  songs: [],
  currentSongIndex: 0,
  searchedSong: null,
  playList: null,
  isPlaying: false,
  aoudioRef1: null,
  audioRef2: null,
  currentAudioRefIndex: null,
  isShuffle: getInitialShuffle(),
  isRepeat: false,
  beforeShuffleSongs: [],

  setBeforeShuffleSongs: (songs: Song[]) => {
    set({ beforeShuffleSongs: songs });
  },

  toggleIsShuffle: (val) => {
    try { localStorage.setItem('4play_shuffle', String(val)); } catch (_) {}
    set((state) => {
      return {
        ...state,
        isShuffle: val,
      };
    });
  },

  toggleIsRepeat: (val) => {
    set({ isRepeat: val });
  },

  setCurrentAudioRefIndex: (index: object) => {
    set({ currentAudioRefIndex: index });
  },

  setAudioRef1: (ref: object) => {
    set({ aoudioRef1: ref });
  },
  setAudioRef2: (ref: object) => {
    set({ audioRef2: ref });
  },

  setIsPlaying: (isPlaying: boolean) => {
    set({ isPlaying });
  },

  setSongs: (songs: Song[], songIndex = 0) => {
    // const updatedSongs = filter(songs, (song) => !song.ignore);
    // set({ songs: updatedSongs, currentSongIndex: songIndex });
    set({ songs, currentSongIndex: songIndex });
  },
  setCurrentSongIndex: (index: number) => {
    console.log("from zustand", index);
    set({ currentSongIndex: index, searchedSong: null });
  },

  // this is for serach bar --> replacking the array with selcted song
  playSearchSong: (song: Song) => {
    set((state) => {
      const formattedSong = getFormattedSong(song);
      return {
        ...state,
        searchedSong: formattedSong,
      };
    });
  },
  setPlayList: (playList: any) => {
    set({ playList, searchedSong: null });
  },

  setPlayListFromScoket: (playList: any, songs, songIndex) => {
    const updatedSongs = filter(songs, (song) => !song.ignore);
    set({
      playList,
      // isShuffle: false,
      searchedSong: null,
      songs: updatedSongs,
      currentSongIndex: songIndex,
    });
  },
}));

export default musicPlayerStore;
